import { ShareProductServiceInterface } from '~/modules/Products/Domain/ShareProductServiceInterface'
import { AnalyticsServiceInterface } from '~/modules/Analytics/Domain/AnalyticsServiceInterface'
import { ShareProductDto } from '~/modules/Products/Domain/ShareProductDto'

export class ShareProductService implements ShareProductServiceInterface {
  private navigator: Navigator
  private segmentAnalyticsService: AnalyticsServiceInterface

  constructor (navigator: Navigator, segmentAnalyticsService: AnalyticsServiceInterface) {
    this.navigator = navigator
    this.segmentAnalyticsService = segmentAnalyticsService
  }

  public isClipboardApiAvailable (): boolean {
    return this.navigator.clipboard !== undefined
  }

  public isShareApiAvailable (): boolean {
    return this.navigator.share !== undefined
  }

  public canShare (): boolean {
    return this.isShareApiAvailable() || this.isClipboardApiAvailable()
  }

  public async share (shareProductDto: ShareProductDto): Promise<void> {
    this.segmentAnalyticsService.trackProductShared({
      productId: shareProductDto.analytics.productId,
      organizer: shareProductDto.analytics.organizer,
      category: shareProductDto.analytics.category,
      collection: shareProductDto.analytics.collection,
    })

    if (this.navigator.share !== undefined) {
      await this.navigator.share({
        text: shareProductDto.title,
        url: shareProductDto.url,
      })
    } else if (this.navigator.clipboard !== undefined) {
      await this.navigator.clipboard.writeText(shareProductDto.url)
    }
  }
}
